import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromLessonActions from '../../actions/lessons-admin.action'
import destroyLesson from '../../../api/administration/lessons/Destroy'
import getCourse from 'api/administration/courses/Get'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleGetCourse(courseId: number) {
  return await getCourse(courseId)
}

async function handleDestroyLesson(lessonId: number) {
  return await destroyLesson(lessonId)
}

function* destroyLessonEffectSaga(action: any) {
  try {
    yield call(handleDestroyLesson, action.lessonId)
    const { lessons } = yield call(handleGetCourse, action.courseId)
    yield put(fromLessonActions.Actions.lessonListReload(lessons))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error: any) {
    ErrorToast(
      I18n.t(
        `administration.toastMessages.${
          error.response.status === 409 ? 'deleteLessonError' : 'deleteError'
        }`
      )
    )
    console.log('error: ', error)
  }
}

export function* destroyLessonWatcherSaga() {
  yield takeLatest(fromLessonActions.LESSONS_DESTROY, destroyLessonEffectSaga)
}
